import { PlatformLocation } from '@angular/common';
import { Component, Inject, Optional, ViewChild } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { BaseComponent } from '../../shared/base-components/base.component';
import { CustomerNameComponent } from './customer-name.component';

export class CustomerNameContext {
    constructor(
        public nameId: number,
        public customerNumberId: number,
        public customerTypeId: number,
        public isAka: boolean
    ) {
    }
}

@Component({
    selector: 'customer-name-modal',
    templateUrl: './customer-name-modal.html'
})
export class CustomerNameModalComponent extends BaseComponent {
    public customerNameId: number;
    public customerNumberId: number;
    public customerTypeId: number;
    public disableSaveButton = false;
    public isAka: boolean;
    public showButtonLoading = false;

    @ViewChild(CustomerNameComponent)
    public customerNameComponent: CustomerNameComponent;

    constructor(
        public location: PlatformLocation,
        public dialogRef: MatDialogRef<CustomerNameModalComponent>,
        @Optional()
        @Inject(MAT_DIALOG_DATA)
        public data: CustomerNameContext
    ) {
        super();
        this.customerNumberId = this.data.customerNumberId;
        this.customerNameId = this.data.nameId;
        this.customerTypeId = this.data.customerTypeId;
        this.isAka = this.data.isAka;
        location.onPopState(() => {
            this.dialogRef.close();
        });
    }

    public ngOnInit(): void {
    }

    public cancel = (): void => {
        this.dialogRef.close();
    };

    public saveName = (): void => {
        this.showButtonLoading = true;
        this.clearValidationResults();
        this.showValidationComponent = false;
        this.disableSaveButton = true;

        this.customerNameComponent.saveName()
            .subscribe({
                next: _ => this.closeDialog(),
                error: response => {
                    if (response && response.validationResults && response.validationResults.length > 0) {
                        this.showButtonLoading = false;
                        this.handleValidationResult(response);
                    }

                    this.showButtonLoading = false;
                }
            });
    };

    private closeDialog = (): void => {
        this.showButtonLoading = false;
        this.disableSaveButton = false;
        this.dialogRef.close(true);
    };
}
